module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l4Jzo"))).then(() => parcelRequire('1iHdE'));